// Added new breakpoints for when navbar gets lower than a certain threshold and text/icons starts to wrap

export const LARGE_CUSTOM_BREAKPOINT = "1250px";
export const TABLET_CUSTOM_BREAKPOINT = "830px";
export const MOBILE_CUSTOM_BREAKPOINT = "430px";
export const SMALL_MOBILE_CUSTOM_BREAKPOINT = "365px";
